import SearchVMBase from "Lib/Fs.SmartClient.Client/SearchVMBase";
import PagingCriteria from "Lib/Fs.Core.Data/PagingCriteria";
import SortingCriteria from "Lib/Fs.Core.Data/SortingCriteria";
import SortBy from "Lib/Fs.Core.Data/SortBy";
import { useView, autoinject, Container } from 'aurelia-framework'
import FsUtility from "Lib/Fs.SmartClient.Client/FsUtility";
import UserEditorVM from "./UserEditorVM";
import { Router } from 'aurelia-router'
import MemberUpdateRequest from "../../../Core/Scripts/AppServiceContract/MemberUpdateRequest";
import MemberData01 from "../../../Core/Scripts/AppServiceContract/MemberData01";
import ManageUserGroupAppService from "../../Scripts/AppServiceContract/ManageUserGroupAppService";
import ManageUserGroupMemberSearchParameter from "../../Scripts/AppServiceContract/ManageUserGroupMemberSearchParameter";
import UserCriteria01 from "../../../Core/Scripts/UserCriteria01";
import { fs } from "../../../../Config/FsConfig";
import UserData01 from "../../Scripts/AppServiceContract/UserData01";

export default class UserSearchVM extends SearchVMBase<UserEditorVM>{
    UserList: UserData01[];

    GroupId: string;
    GroupCode: string;
    SelectedUserId: string;
    SelectedUser: UserData01;

    Template: any;
    ServiceBaseUrl: any;
    Router: Router;
    DataSourceUser: any;

    criteria: string;

    constructor(groupId) {
        super(UserEditorVM);
        var self = this;

        this.Router = Container.instance.get(Router);
        this.ServiceBaseUrl = fs.Config.ServiceBaseUrl;
        this.GroupCode = null;

        self.GroupId = groupId;
        this.criteria = "";
        this.IsSearchAfterSave = true;
        this.IsClearSelectionAfterSave = true;
        self.Load(groupId);
    }

    getUser() {
        var self = this;
        var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;

        service.FindUserAutoCompleteData(this.criteria).done((result) => {
            self.UserList = result;
        }).fail(FsUtility.CommonErrorHandler);
    }

    FindUserData(params, success, failure) {
        var self = this;
        var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;

        var data = params.data.term == null ? "" : params.data.term;
        //if (params.data.term != null) {
        service.FindUserAutoCompleteData(data).done((result) => {
                self.UserList = result;
                success(result);
            }).fail((error) => {
                FsUtility.CommonErrorHandler(error);
                failure(error);
            });
        //}
    }

    Save() {
        var self = this;

        if (self.SelectedUserId == null) {
            return;
        }

        var request = this.CreateRequest();
        var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;

        service.AddMember(request)
            .done((result) => {
                self.SetAfterSave();
                self.Search();
                FsUtility.AlertModal("The item has been saved successfully", 1, 1);
            }).fail(FsUtility.CommonErrorHandler);
    }

    SetAfterSave() {
        var self = this;

        self.SelectedUserId = null;
    }

    CreateRequest(): MemberUpdateRequest {
        var request = new MemberUpdateRequest();
        request.GroupUID = this.GroupId;
        request.UserUID = this.SelectedUserId;
        return request;
    }

    getTemplate(e: any) {
        var key = e.target.data('title');
        this.CurrentItem.ErrorList = this.CurrentItem.getValidateErrors(key);
        return () => this.Template.template
    }

    Load(groupId: string) {
        var self = this;
        if (groupId != null && groupId != 'undefined') {
            this.Search();
            self.GroupId = groupId;
        }
    };

    SearchItems(searchCallback: (result: MemberData01[]) => void, sortingCriteria: SortingCriteria, pagingCriteria: PagingCriteria) {
        var self = this;
        var criteria = new ManageUserGroupMemberSearchParameter();
        criteria = this.CreateCriteria();
        criteria.SortingCriteria = sortingCriteria;
        criteria.PagingCriteria = pagingCriteria;

        var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;
        service.FindMember(criteria)
            .done((result) => {
                searchCallback(result);
            }).fail(FsUtility.CommonErrorHandler);
    }

    PrepareDefaultSortingCriteria(sortingCriteria: SortingCriteria) {
        var sortBy = new SortBy();
        sortBy.Direction = 0;
        sortBy.Name = "UserCode";
        sortingCriteria.push(sortBy);
    }

    CountItems(countCallback: (result: number) => void) {
        var self = this;
        var req = self.CreateCriteria();

      var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;

      if (!this.CheckCriteriaEquals(req.Criteria)) {
        this.SearchCriteria = req.Criteria;
        service.CountMember(req.Criteria)
            .done((result) => {
                countCallback(result)
            }).fail(FsUtility.CommonErrorHandler);
      } else {
        countCallback(this.ItemCount);
      }
    }

  SearchCriteria: UserCriteria01;

  CheckCriteriaEquals(searchCriteria: UserCriteria01) {
    if (this.SearchCriteria == null) return false;
    return JSON.stringify(this.SearchCriteria) == JSON.stringify(searchCriteria);
  }

    CreateCriteria(): ManageUserGroupMemberSearchParameter {
        var req = new ManageUserGroupMemberSearchParameter();
        var cri = new UserCriteria01();
        cri.Code = $.trim(this.GroupCode);
        cri.UserUID = this.GroupId;
        req.Criteria = cri;
        return req;
    }

    RemoveItem(item: UserEditorVM) {

        var self = this;
        var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;

        var request = new MemberUpdateRequest();
        request.GroupUID = this.GroupId;
        request.UserUID = item.Id;

        FsUtility.AlertModal("Are you sure to delete ?", 3, 3, function (result) {
            if (result == true) {
                service.RemoveMember(request)
                    .done((result) => {
                        FsUtility.AlertModal("The item has been updated successfully", 2, 1);
                        self.Search();
                    }).fail(FsUtility.CommonErrorHandler);
            }
        });
    }

    RemoveAll() {

        var self = this;
        var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;

        FsUtility.AlertModal("Are you sure to delete ?", 3, 3, function (result) {
            if (result == true) {

                var failCount = 0;

                for (var i = 0; i < self.SelectedItems.length; i++) {

                    var item = self.SelectedItems[i];

                    var request = new MemberUpdateRequest();
                    request.GroupUID = self.GroupId;
                    request.UserUID = item.Id;
                    service.RemoveMember(request)
                        .done((result) => {
                            self.Search();
                        }).fail(FsUtility.CommonErrorHandler);
                }
            }
        });
    }


    
}
